module.exports = "<dl class=\"form-element\">\n    <dt>\n        <label>Firma</label>\n    </dt>\n    <dd>\n        <select\n            ng-class=\"IssueFormCompaniesCtrl.isFullWidth ? 'full-width' : ''\"\n            name=\"company\"\n            ng-model=\"IssueFormCompaniesCtrl.company\"\n            ng-options=\"item as item.name for item in IssueFormCompaniesCtrl.dataFromBackend track by item.id\"\n        >\n            <option value=\"\">Wybierz firmę</option>\n        </select>\n    </dd>\n</dl>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/issue_forms/fragments/companies/issue_form_companies.html
// module id = 652
// module chunks = 0